export default "__VITE_ASSET__d275f19d__"